module.exports = __webpack_public_path__ + "img/service-212.49ddb8ba.png";